import { StatusData } from "../../../../types/api/dashboard";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

const StatusChart = ({statusData}: {statusData: StatusData[]}) => {
  return (
    <ResponsiveContainer width="100%" height={220}>
      <PieChart>
        <Pie
          data={statusData}
          dataKey="value"
          nameKey="name"
          innerRadius={70}
          outerRadius={100}
        >
          {statusData.map((entry) => (
            <Cell
              key={entry.name}
              fill={entry.color}
            />
          ))}
        </Pie>

        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default StatusChart